
<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Visualisation de l'évolution des critères du patient </div>
        <div class="modal-body">

            <div  class="message-wrapper">
                <span>
                    {{ patients.length }} patient{{ patients.length > 1 ? '(s)' : '' }}
                    {{ patients.length > 1 ? 'existent' : 'existe' }}
                    avec les même nom, prénom et date de naissance.
                </span>
                <br>
                <br>
                <span>
                    Vous pouvez sélectionner un patient de la liste pour accéder à sa fiche
                    <br>
                    ou créer un nouveau patient avec les informations précédemment renseignées.
                </span>
            </div>

            <div class="patients-table-wrapper">

                <frg-table [keysBody]="patientList" [keysColumn]="patientsColumnTable"
                    [isRowsClickable]="true" (onClickRow)="selectLine($event)"
                    class="patient-table">
                </frg-table>

            </div>
            <div class="button-wrapper">
                <div>
                    <frg-button (activated)="selectPatient()" [disabled]="!selectedPatient"
                    fullWidth="true" [backgroundColor]="'var(--primary)'">Sélectionner le patient</frg-button>
                </div>

                <div class="buttons">
                    <frg-button (activated)="closeModal()"
                        fullWidth="true" [backgroundColor]="'var(--danger)'">Annuler</frg-button>

                    <frg-button (activated)="createPatient()"
                        fullWidth="true" [backgroundColor]="'var(--primary)'">Créer</frg-button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>